<template>
  <div class="mb-12" :class="$vuetify.breakpoint.name === 'lg' ? 'pr-12 pl-8' : 'px-3'">
    <v-dialog v-model="dialog.delete" persistent max-width="400">
      <v-card class="pa-3">
        <v-card-title class="title">Peringatan !</v-card-title>
        <v-card-text>Apakah anda yakin ingin menghapus data ini ?</v-card-text>
        <v-card-actions class="pb-5">
          <v-spacer></v-spacer>
          <v-btn
            rounded
            small
            width="70"
            color="#3a3a3a"
            elevation="0"
            :disabled="process.form"
            :loading="process.form"
            class="white--text text-capitalize"
            @click="deletes">
            Yakin
          </v-btn>
          <v-btn
            rounded
            small
            width="70"
            elevation="0"
            class="text-capitalize"
            :disabled="process.form"
            @click="dialog.delete = false">
            Tidak
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog.form" persistent max-width="400">
      <v-card class="pa-3">
        <div v-if="selectedPage === 'create' || selectedPage === 'update'">
          <div class="title text--secondary mb-5">
            {{ selectedPage === 'create' ? 'Tambah' : 'Ubah' }} Sub Menu
          </div>
          <ValidationObserver ref="observer">
            <v-form>
              <ValidationProvider name="Nama" rules="required" v-slot="{ errors }">
                <v-text-field
                  dense
                  outlined
                  label="Nama"
                  color="#3a3a3a"
                  v-model="form.subMenuName"
                  :error-messages="errors"
                  require>
                </v-text-field>
              </ValidationProvider>
              <ValidationProvider name="Url" rules="required" v-slot="{ errors }">
                <v-text-field
                  dense
                  outlined
                  label="Url"
                  color="#3a3a3a"
                  v-model="form.subMenuUrl"
                  :error-messages="errors"
                  require>
                </v-text-field>
              </ValidationProvider>
              <div
                class="caption font-italic font-weight-light grey--text text--darken-1">
                *note: Silahkan pilih icon yang akan digunakan
              </div>
              <v-item-group v-model="selected">
                <v-row class="align-center">
                  <v-col v-for="(item, i) in icon" :key="i" cols="3">
                    <v-item v-slot:default="{toggle }">
                      <div
                        @click="toggle"
                        class="text-center cursor-pointer div-icon"
                        :class="form.subMenuIcon === item.icon ? 'active-icon' : ''">
                       <v-icon :color="form.subMenuIcon == item.icon ? '#3a3a3a' : ''">{{ item.icon }}</v-icon>
                      </div>
                    </v-item>
                  </v-col>
                </v-row>
              </v-item-group>
              <div>
                <v-alert type="error" text dense prominent v-show="response !== ''">{{ response }}</v-alert>
              </div>
              <v-card-actions class="mt-2">
                <v-spacer></v-spacer>                
                <v-btn
                  small
                  rounded
                  width="100"
                  color="#FF618A"
                  elevation="0"
                  :disabled="process.form || selected === ''"
                  :loading="process.form"
                  @click="save"
                  class="white--text text-capitalize">
                  Simpan
                </v-btn>
                <v-btn
                  rounded
                  small
                  width="100"
                  elevation="0"
                  class="text-capitalize"
                  :disabled="process.form"
                  @click="reset(undefined, 'mobile'); selectedPage = 'create'; $refs.observer.reset()">
                  Batal
                </v-btn>
              </v-card-actions>
            </v-form>
          </ValidationObserver>
        </div>

        <div v-if="selectedPage === 'detail'">
          <div class="text-center">
            <v-icon x-large>{{detail.submenuIcon}}</v-icon>
          </div>
          <div class="mt-10">
            <v-list-item-title
              class="body-2 grey--text text--darken-2">
              <p class="caption grey--text text-lighten-4 mb-1">
                Judul
              </p>
              {{detail.submenuTitle}}
            </v-list-item-title>
            <v-list-item-title
              class="body-2 grey--text text--darken-2 mt-2">
              <p class="caption grey--text text-lighten-4 mb-1">
                Url
              </p>
              {{detail.submenuUrl}}
            </v-list-item-title>
          </div>
          <v-card-actions class="pb-5">
            <v-spacer></v-spacer>
            <v-btn
              rounded
              small
              width="100"
              elevation="0"
              class="text-capitalize"
              @click="reset(undefined, 'mobile');dialog.form = false;">
              Tutup
            </v-btn>
          </v-card-actions>
        </div>
      </v-card>
    </v-dialog>
    <v-row>
      <v-col cols="12" :sm="!showPage ? '12' : '8'">
        <div :class="$vuetify.breakpoint.name !== 'xs' ? 'd-flex' : ''">
          <v-text-field
            filled
            rounded
            dense
            :hide-details="true"
            placeholder="Cari sub menu . . ."
            v-model="filter.title"
            clearable
            color="#ff618a"
            @click:clear="filter.title = ''; fetch();showPage = false"
            v-on:keyup.enter="fetch(); showPage = false"
            prepend-inner-icon="mdi-magnify">
          </v-text-field>
          <v-btn 
            :color="!showPage ? '#FF618A' : '#F5F5F5'"
            :width="$vuetify.breakpoint.name === 'xs' ? '100%' : '200'"
            class="text-capitalize"
            :class="$vuetify.breakpoint.name === 'xs' ? 'mt-3' : 'mx-3'"
            :dark="!showPage"
            elevation="0"
            rounded
            :disabled="process.form"
            :light="showPage"
            v-on:click="$vuetify.breakpoint.name === 'xs' ? reset(undefined, 'mobile') : $vuetify.breakpoint.name === 'sm' ? reset(undefined, 'mobile') : reset()"
            @click="selectedPage = 'create';">
            <span v-if="!showPage">
              Tambah Sub Menu 
            </span>
            <span v-if="showPage">
              Kembali
            </span>
          </v-btn>
        </div>
        <div class="my-5">
          <div class="title text--secondary">
            Data Sub Menu
          </div>
          <div class="caption text--secondary">
            {{pagination.totalData}} Sub Menu Ditemukan
          </div>
          <v-skeleton-loader
            class="ma-auto"
            :loading="process.run"
            transition="scale-transition"
            type="list-item-avatar-two-line"
            v-for="(l, index) in process.run ? 10:list"
            :key="index">
            <v-list dense class="line my-3 mr-5">
              <v-list-item>
                <v-list-item-avatar tile @click="$vuetify.breakpoint.name === 'xs' ? toDetail(l, 'mobile') : $vuetify.breakpoint.name === 'sm' ? toDetail(l, 'mobile') : toDetail(l)" class="cursor-pointer">
                  <v-icon>{{l.submenuIcon}}</v-icon>
                </v-list-item-avatar>
                <v-list-item-content @click="$vuetify.breakpoint.name === 'xs' ? toDetail(l, 'mobile') : $vuetify.breakpoint.name === 'sm' ? toDetail(l, 'mobile') : toDetail(l)" class="cursor-pointer">
                  <v-list-item-title
                    class="body-2 font-weight-bold grey--text text--darken-2">
                    {{l.submenuTitle}}
                  </v-list-item-title>
                </v-list-item-content>
                <v-list-item-content class="ml-3 text-right">
                  <div>
                    <v-btn 
                      fab
                      x-small
                      color="#269B91"
                      elevation="0"
                      :disabled="process.form"
                      class="text-capitalize ma-1 white--text"
                      v-on:click="$vuetify.breakpoint.name === 'xs' ? reset(l, 'mobile') : $vuetify.breakpoint.name === 'sm' ? reset(l, 'mobile') : reset(l)"
                      @click="selectedPage = 'update'">
                      <v-icon small>mdi-square-edit-outline</v-icon>
                    </v-btn>
                    <v-btn 
                      fab
                      x-small
                      color="red"
                      :disabled="process.form"
                      elevation="0"
                      class="text-capitalize white--text ma-1"
                      @click="form.subMenuId = l.id; dialog.delete = true;">
                      <v-icon small>mdi-trash-can-outline</v-icon>
                    </v-btn>
                  </div>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-skeleton-loader>
          <Empty v-show="!process.run && list.length < 1" content="Data Sub Menu"/>
          <div v-if="pagination.totalPage > 1">
            <v-row>
              <v-col cols="5">
                <div class="body-2	font-weight-bold mt-4">
                  Total {{ pagination.totalData }} data
                </div>
              </v-col>
              <v-col cols="7">
                <div class="float-right">
                  <v-pagination
                    v-model="page"
                    :length="pagination.totalPage"
                    :total-visible="5"
                    color="#FF618A"
                    @input="fetch(page); showPage = false"
                    circle>
                  </v-pagination>
                </div>
              </v-col>
            </v-row>
          </div>
        </div>
      </v-col>

      <v-col cols="12" sm="4" class="mt-3 background-default pa-7" v-if="showPage && $vuetify.breakpoint.name !== 'xs'">
        <div v-if="selectedPage === 'create' || selectedPage === 'update'">
          <div class="title text--secondary mb-5">
            {{ selectedPage === 'create' ? 'Tambah' : 'Ubah' }} Sub Menu
          </div>
          <ValidationObserver ref="observer">
            <v-form>
              <ValidationProvider name="Nama" rules="required" v-slot="{ errors }">
                <v-text-field
                  dense
                  outlined
                  label="Nama"
                  color="#3a3a3a"
                  v-model="form.subMenuName"
                  :error-messages="errors"
                  require>
                </v-text-field>
              </ValidationProvider>
              <ValidationProvider name="Url" rules="required" v-slot="{ errors }">
                <v-text-field
                  dense
                  outlined
                  label="Url"
                  color="#ff618a"
                  v-model="form.subMenuUrl"
                  :error-messages="errors"
                  require>
                </v-text-field>
              </ValidationProvider>
              <div
                class="caption font-italic font-weight-light grey--text text--darken-1">
                *note: Silahkan pilih icon yang akan digunakan
              </div>
              <v-item-group v-model="selected">
                <v-row class="align-center">
                  <v-col v-for="(item, i) in icon" :key="i" cols="12" md="3">
                    <v-item v-slot:default="{toggle}">
                      <div
                        @click="toggle"
                        class="text-center cursor-pointer div-icon"
                        :class="form.subMenuIcon === item.icon ? 'active-icon' : ''">
                       <v-icon :color="form.subMenuIcon == item.icon ? '#ff618a' : ''">{{ item.icon }}</v-icon>
                      </div>
                    </v-item>
                  </v-col>
                </v-row>
              </v-item-group>
              <div>
                <v-alert type="error" text dense prominent v-show="response !== ''">{{ response }}</v-alert>
              </div>
              <v-card-actions class="mt-2">
                <v-spacer></v-spacer>
                <v-btn
                  rounded
                  width="200"
                  color="#FF618A"
                  elevation="0"
                  :disabled="process.form || selected === ''"
                  :loading="process.form"
                  @click="save"
                  class="white--text text-capitalize">
                  Simpan
                </v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-form>
          </ValidationObserver>
        </div>

        <div v-if="selectedPage === 'detail'">
          <div class="text-center">
            <v-icon x-large>{{detail.submenuIcon}}</v-icon>
          </div>
          <div class="mt-10">
            <v-list-item-title
              class="body-2 grey--text text--darken-2">
              <p class="caption grey--text text-lighten-4 mb-1">
                Judul
              </p>
              {{detail.submenuTitle}}
            </v-list-item-title>
            <v-list-item-title
              class="body-2 grey--text text--darken-2 mt-2">
              <p class="caption grey--text text-lighten-4 mb-1">
                Url
              </p>
              {{detail.submenuUrl}}
            </v-list-item-title>
          </div>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import { get, post, put, destroy } from "../../../../service/Axios";
  import Empty from "../../../../components/DataEmpty";
  export default {
    data() {
      return {
        icon: [
          {
            icon: "mdi-chart-line",
          },
          {
            icon: "mdi-account-tie",
          },
          {
            icon: "mdi-account-group",
          },
          {
            icon: "mdi-library",
          },
          {
            icon: "mdi-cogs",
          },
          {
            icon: "mdi-book-open-page-variant"
          },
          {
            icon: "mdi-tag",
          },
          {
            icon: "mdi-tag-multiple",
          },
          {
            icon: "mdi-view-grid-outline",
          },
          {
            icon: "mdi-wallet",
          },
          {
            icon: "mdi-shield-key"
          },
          {
            icon: "mdi-newspaper-variant"
          },
          {
            icon: "mdi-laptop-chromebook"
          },
          {
            icon: "mdi-folder-multiple"
          },
          {
            icon: "mdi-arrow-right-bold-circle"
          },
          {
            icon: "mdi-arrow-right-bold"
          },
          {
            icon: "mdi-telegram"
          },
          {
            icon: "mdi-web"
          }
        ],
        dialog: {
          delete: false,
          form: false
        },
        selected: "",
        showPage: false,
        selectedPage: '',
        filter: {
          title: ""
        },
        detail: {},
        list: [],
        pagination: {},
        page: 1,
        form: {
          subMenuId: "",
          subMenuName: "",
          subMenuUrl: "",
          subMenuIcon: ""
        },
        process: {
          form: false,
          run: false
        },
        response: ""
      };
    },
    components: {
      Empty
    },
    watch: {
      selected(val) {
        this.form.subMenuIcon = val !== '' ? this.icon[val].icon : ''
      }
    },
    mounted() {
      window.scrollTo(0, 0);
      this.fetch();
    },
    methods: {
      async fetch(p) {
        if (p === undefined) {
          this.page = 1
        }
        this.process.run = true;
        await get(`api/internal/submenu/list`,{
            params: {
              pagenum: p,
              limit: 10,
              title: this.filter.title
            }
          })
        .then(response => {
          let res = response.data
          if (res.code === 200) {
            this.process.run = false
            this.list = res.data
            this.pagination = res.pagination
          }
        })
      },
      toDetail(item, status) {
        this.detail = item
        this.selectedPage = "detail"
        this.showPage = status !== undefined ? false : true
        this.dialog.form = status !== undefined ? true : false
      },
      reset(item, status) {
        this.showPage = status !== undefined ? false : !this.showPage ? true : false

        this.form = {
          subMenuId: item !== undefined ? item.id : "",
          subMenuName : item !== undefined ? item.submenuTitle : "",
          subMenuUrl : item !== undefined ? item.submenuUrl : "",
          subMenuIcon : item !== undefined ? item.submenuIcon : ""
        }

        if (this.form.subMenuIcon !== '') {
          for (let i in this.icon) {
            if (this.icon[i].icon === this.form.subMenuIcon) {
              this.selected = parseInt(i)
            }
          }
        } else {
          this.selected = ""
        }

        this.selectedPage = ''
        this.process.form = false
        this.dialog.form = status !== undefined ? !this.dialog.form ? true : false : false

        this.response = ''
      },
      async save() {
        this.response = "";
        const isValid = await this.$refs.observer.validate();
        if (isValid) {
          if (this.form.subMenuId === "") {
            this.creates();
          } else {
            this.updates();
          }
        }
      },
      async creates() {
        this.process.form = true;
        await post(`api/internal/submenu/create`, {
          data: {
            submenuTitle: this.form.subMenuName,
            submenuUrl: this.form.subMenuUrl,
            submenuIcon: this.form.subMenuIcon
          }
        }).then(response => {
          let res = response.data;
          if (res.code == 201) {
            this.fetch();
            if (this.dialog.form === true) {
              this.reset(undefined, 'mobile')
            } else {
              this.reset();
            }
          } else {
            this.process.form = false;
            this.response = res.msg;
          }
        });
      },
      async updates() {
        this.process.form = true;
        await put(`api/internal/submenu/update/${this.form.subMenuId}`, {
          data: {
            submenuTitle: this.form.subMenuName,
            submenuUrl: this.form.subMenuUrl,
            submenuIcon: this.form.subMenuIcon
          }
        }).then(response => {
          let res = response.data;
          if (res.code === 201) {
           this.fetch(this.page)
            if (this.dialog.form === true) {
              this.reset(undefined, 'mobile')
            } else {
              this.reset();
            }
          } else {
            this.process.form = false;
            this.response = res.msg;
          }
        });
      },
      async deletes() {
        this.process.form = true;
        await destroy(`api/internal/submenu/delete/${this.form.subMenuId}`).then((response) => {
          let res = response.data;
          if (res.code === 201) {
            this.process.form = false
            this.dialog.delete = false
            this.showPage = false
            this.fetch()
          } else {
            this.process.form = false
            this.response = res.msg
          }
        })
      }
    }
  }
</script>

<style scoped>
.active-icon {
  background: #fff;
  color: #f0932b;
  box-shadow: 0px 0px 0px -3px rgba(0, 0, 0, 0.2),
    0px 0px 0px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12) !important;
}
.div-icon {
  display: flex;
  justify-content: center;
  height: 35px;
  width: 45px;
}
</style>

